(function (global, factory) {
	if (typeof define === "function" && define.amd) {
		define(["module", "exports"], factory);
	} else if (typeof exports !== "undefined") {
		factory(module, exports);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod, mod.exports);
		global.VueConstants = mod.exports;
	}
})(this, function (module, exports) {
	"use strict";

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		install: function install(Vue, options) {
			Vue.mixin({
				beforeCreate: function beforeCreate() {
					var constants = this.$options.constants;
					if (!constants) return;

					for (var key in constants) {
						if (constants.hasOwnProperty(key)) this[key] = constants[key];
					}
				}
			});
		}
	};
	module.exports = exports["default"];
});